// extracted by mini-css-extract-plugin
module.exports = {"CreatePage__error__3ZtsP":"CreatePage__error__3ZtsP","CreatePage__form__31hYB":"CreatePage__form__31hYB","CreatePage__text-field__2yJAl":"CreatePage__text-field__2yJAl"};